import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'
import PropTypes from 'prop-types'
import { SET_DRAWER_STATE } from 'modules/App/types'
import { useDispatch } from 'react-redux'
import { LOCALES } from 'constants/app-config'

const pathWithoutLocalePrefix = (pathname = '') => {
  const stripped = pathname.replace(new RegExp(`^\\/(${LOCALES.join('|')})(?=\\/|$)`), '')
  return stripped === '' ? '/' : stripped
}

const ScrollToTop = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const prevLogicalPathRef = useRef()

  useEffect(() => {
    const logicalPath = pathWithoutLocalePrefix(location.pathname)
    const onlyLocaleChanged =
      prevLogicalPathRef.current !== undefined && prevLogicalPathRef.current === logicalPath

    prevLogicalPathRef.current = logicalPath

    if (onlyLocaleChanged) {
      return
    }

    window.scrollTo(0, 0)
    dispatch({ type: SET_DRAWER_STATE, payload: { opened: false } })
  }, [location.pathname, dispatch])

  return null
}

ScrollToTop.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
}

export default ScrollToTop
